module.exports = __webpack_public_path__ + "img/active2019.07eaffe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/active2019.jpg
// module id = 934
// module chunks = 1